import type { Variants } from 'framer-motion';

export const dropIn: Variants  = {
  hidden: {
    y: "-90vh",
    opacity: 0,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 32,
      stiffness: 500,
    },
  },
  exit: {
    y: "80vh",
    opacity: 0,
  },
};
